/**
 * Mock do Log de disparos (VITE_USE_MOCKS=true):
 *   GET /dispatch_runs                   → lista de execuções
 *   GET /dispatch_runs/:id/results       → pra quem deu certo / falhou
 * Uma execução nova (com dispositivo e motivo) e uma antiga (push sem motivo gravado).
 */

type ResultStatus = 'success' | 'failed';

interface MockResult {
  _id: string;
  userName: string;
  iduser: string;
  serialNumber: string;
  typeAccess?: string;
  status: ResultStatus;
  return_message: string;
  date: string;
}

const NEW_RUN = '66f0a1b2c3d4e5f6a7b8c9d0';
const OLD_RUN = '66e0a1b2c3d4e5f6a7b8c9d1';
const NAMES = ['Ana Souza', 'Bruno Lima', 'Carla Dias', 'Diego Alves', 'Elisa Rocha', 'Fábio Costa', 'Gabi Nunes'];
const DEVICES = ['iOS', 'APP-ios', 'APP-android', 'gwallet', 'Android'];
const FAILURES: Array<{ typeAccess: string; reason: string }> = [
  { typeAccess: 'APP-android', reason: 'App desinstalado ou token expirado (token removido)' },
  { typeAccess: 'iOS', reason: 'Apple: Unregistered' },
  { typeAccess: 'APP-ios', reason: 'Token de outro projeto Firebase (SenderId) (token removido)' },
  { typeAccess: 'Android', reason: 'PassWallet: HTTP 400' },
];

function buildResults(runStart: Date, legacy: boolean): MockResult[] {
  const rows: MockResult[] = [];
  for (let i = 0; i < 180; i++) {
    const base = {
      _id: `r${i}`,
      userName: `${NAMES[i % NAMES.length]} ${i + 1}`,
      iduser: `u${i % 150}`,
      serialNumber: `SN${100000 + (i % 150)}`,
      date: new Date(runStart.getTime() + i * 3000).toISOString(),
    };
    if (i % 13 === 0) {
      const failure = FAILURES[i % FAILURES.length];
      rows.push(
        legacy
          ? { ...base, status: 'failed', return_message: 'Bubble Mix - Centro | Promo de setembro' }
          : { ...base, status: 'failed', typeAccess: failure.typeAccess, return_message: failure.reason },
      );
    } else {
      rows.push({
        ...base,
        status: 'success',
        typeAccess: legacy ? undefined : DEVICES[i % DEVICES.length],
        return_message: 'Bubble Mix - Centro | Promo de setembro',
      });
    }
  }
  return rows;
}

const now = Date.now();
const RUNS = [
  { _id: NEW_RUN, start: new Date(now - 2 * 60 * 60 * 1000), total: 150, legacy: false, campaign: 'mock-campanha' },
  { _id: OLD_RUN, start: new Date(now - 3 * 24 * 60 * 60 * 1000), total: 150, legacy: true, campaign: 'mock-campanha-antiga' },
].map((run) => ({ ...run, results: buildResults(run.start, run.legacy) }));

function summary(run: (typeof RUNS)[number], passbookId: string | undefined) {
  const failed = run.results.filter((r) => r.status === 'failed').length;
  return {
    _id: run._id,
    id_passbook: passbookId,
    id_campanha: run.campaign,
    tipo_campanha: 'C',
    tipo_disparo: 'push',
    total: run.total,
    status: 'success' as const,
    error: null,
    created_at: run.start.toISOString(),
    finished_at: run.start.toISOString(),
    sent: run.results.length,
    failed,
  };
}

/** `segments` = partes do caminho depois de "dispatch_runs". Devolve null se não for rota do mock. */
export function mockDispatchRuns(segments: string[], query: URLSearchParams, passbookId: string | undefined): unknown {
  if (segments.length === 0) return RUNS.map((run) => summary(run, passbookId));

  if (segments.length === 2 && segments[1] === 'results') {
    const run = RUNS.find((r) => r._id === segments[0]);
    if (!run) return null;
    const status = query.get('status');
    const q = (query.get('q') ?? '').toLowerCase();
    let rows = run.results;
    if (status === 'success' || status === 'failed') rows = rows.filter((r) => r.status === status);
    if (q) rows = rows.filter((r) => r.userName.toLowerCase().includes(q) || r.serialNumber.toLowerCase() === q);
    const page = Number(query.get('page') ?? 0);
    const pageSize = Number(query.get('pageSize') ?? 25);
    const sorted = [...rows].sort((a, b) => b.date.localeCompare(a.date));
    const base = summary(run, passbookId);
    return {
      run: { ...base, success: base.sent - base.failed, updated_at: run.results[run.results.length - 1].date },
      rows: sorted.slice(page * pageSize, page * pageSize + pageSize),
      total: sorted.length,
    };
  }

  return null;
}
